import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();
  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyDetail({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);

  return (
    <div>
      <table className={'preview-table preview-white-table  preview-bottom-border'}>
        <colgroup>
          <col width={'25%'} />
          <col width={'25%'} />
          <col width={'20%'} />
          <col width={'5%'} />
          <col width={'25%'} />
        </colgroup>
        <tbody>
          <tr>
            <td style={{ height: '2.5rem', alignContent: 'center' }}>
              <input type={'checkbox'} className={'preview-checkbox large'} />
              &nbsp;&nbsp;&nbsp;
              <label>Plot Plan / Drawing</label>
            </td>
            <td style={{ height: '2.5rem', alignContent: 'center' }}>
              <input type={'checkbox'} className={'preview-checkbox large'} />
              &nbsp;&nbsp;&nbsp;<label>Checklist</label>
            </td>
            <th rowSpan={2}>
              Valid
              <br />
              Date
            </th>
            <th>From</th>
            <td></td>
          </tr>
          <tr>
            <td style={{ height: '2.5rem', alignContent: 'center' }}>
              <input type={'checkbox'} className={'preview-checkbox large'} />
              &nbsp;&nbsp;&nbsp;<label>Work Permit</label>
            </td>
            <td style={{ height: '2.5rem', alignContent: 'center' }}>
              <input type={'checkbox'} className={'preview-checkbox large'} />
              &nbsp;&nbsp;&nbsp;<label>Excavation Plan</label>
            </td>
            <th>To</th>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
